@let isShoppingCartMobileView = shoppingCartEnabled && isMobile();
<fin-itinerary-modal [itineraryModal]="itineraryModal" (closed)="itineraryModalClosed$.emit($event)" />

<ng-template #seatMapWithShoppingCart>
  <div class="inner-grid">
    <div class="col-1-12">
      <ng-container *ngTemplateOutlet="seatPreSelectionTemplate"></ng-container>
    </div>
    @if (showDesktopCart()) {
      <aside class="cart-wrapper col-9-12">
        <fin-shopping-cart></fin-shopping-cart>
      </aside>
    }
  </div>
</ng-template>

<ng-template #seatPreSelectionTemplate>
  <fin-ancillary-header [title]="'ancillaries.seats.title' | finLocalization">
    <div class="teaser-wrapper font-body-1 flex flex--space-between mr-medium-t flex--middle font-body-medium">
      <span>{{ 'ancillaries.seats.usDotMessage' | finLocalization }}</span>
      <fcom-button
        data-testid="seatmap-sellection-skip-button"
        class="mr-medium-l"
        [text]="'ancillaries.seats.skipSeatSelection' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        (clickBtn)="skipSeatSelection('top')"
      />
    </div>

    <fin-ancillary-flight-bound-selector
      class="pr-small-t mobile-bleed"
      [showFlightCard$]="showFlightCard$"
      [boundsOrFlights]="flights$ | async"
      [activeBoundIndex]="slideIndex$ | async"
      [passengers]="passengers$ | async"
      (selectIndex)="slideIndex$.next($event)"
      (viewDetails)="viewDetails()"
      [locations]="locations"
      [focusOnDetails$]="itineraryModalClosed$"
    />
  </fin-ancillary-header>

  <div class="overflow-hidden mobile-bleed">
    <div class="slider nowrap fill slide-{{ slideIndex$ | async }}">
      @for (flight of flights$ | async; let i = $index; track flightsTrackBy($index, flight)) {
        <div class="inline-block valign-top fill">
          <fin-seat-map-view
            [flight]="flight"
            [passengers]="travelers()"
            [flightIsActive$]="i === (slideIndex$ | async) | finToObservable"
            [cartOrOrder$]="cartOrOrder$"
            [availability$]="flightAncillaryAvailability$"
            [ancillaryLoader$]="ancillaryLoader$"
            [purchaseFlow]="purchaseFlow$ | async"
            (retrySeatmap)="flightSelected.emit(flight)"
            (changeSeats)="changeSeats($event)"
            [contextCategory]="Category.SEAT"
          />
        </div>
      }
    </div>
  </div>
</ng-template>

@if (shoppingCartEnabled) {
  <ng-container *ngTemplateOutlet="seatMapWithShoppingCart"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="seatPreSelectionTemplate"></ng-container>
}

@if (translationKey$ | async; as translationKey) {
  <fcom-cta-button
    data-testid="common-booking-ancillaries-seat-map-pre-selection-cta-button"
    [visible]="true"
    [title]="translationKey.key | finLocalization"
    [position]="isShoppingCartMobileView ? ButtonPosition.GRID_FILL_MOBILE : ButtonPosition.GRID"
    [loading]="(seatMapPreloadingEnabled$ | async) ? (selectionLoading$ | async) : false"
    [removeContentPadding]="isShoppingCartMobileView"
    [theme]="
      (hasSelections$ | async) === true ? ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER : ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
    "
    (buttonClicked)="continue()"
  >
    @if (shoppingCartEnabled) {
      <div
        class="nordic-blue-50-bg surface-secondary nordic-blue-900-text text-icon-primary flex flex--space-between ps-small font-body-1 elevation-level-2--inverted dn-laptop-up font-body-medium"
      >
        <div>
          <fcom-icon [name]="SvgLibraryIcon.SHOPPING_CART"></fcom-icon>
          <fcom-link class="ps-small-l" (beforeNavigation)="openShoppingCart()">
            {{ 'shoppingCart.viewYourCart' | finLocalization }}
          </fcom-link>
        </div>
        <div>
          <span>{{ 'shoppingCart.totalPriceShort' | finLocalization }}</span>
          <span class="bold-type">
            {{ totalPrice$ | async | finPrice | finEmpty: '&ndash;' }}
          </span>
        </div>
      </div>
    }
    <div [class.dn-laptop-down]="shoppingCartEnabled">
      <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
      @if (totalPoints$ | async; as points) {
        <span class="font-body-1 font-body-medium" data-testid="cta-points"
          >{{ 'award.points' | finLocalization: { pointsAmount: points || 0 | finPoints } }}&nbsp;+
        </span>
      }
      <span class="font-body-1 bold-type font-body-medium-bold">{{
        totalPrice$ | async | finPrice | finEmpty: '&ndash;'
      }}</span>
    </div>
  </fcom-cta-button>
}
